// Copyright (c) 2020 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as ManualTimeSlice from "../slice"
import {
  SearchRecentManualTimeCommentsRequest,
  SearchRecentManualTimeCommentsResponse,
} from "generated/wisetime/user/preferences/v4/preferences_pb"
import { grpc } from "../../../app/rpc/executor"
import { preferencesClient } from "../../../app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type SearchRecentManualTimeCommentsRpc = (request: SearchRecentManualTimeCommentsRequest) => Observable<SearchRecentManualTimeCommentsResponse>

export const searchRecentManualTimeComments = (searchRecentManualTimeCommentsRpc: SearchRecentManualTimeCommentsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchRecentManualTimeComments.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(searchRecentManualTimeCommentsRpc),
        map(t => t.toObject()),
        map(ManualTimeSlice.setCachedManualTimeComments),
        catchError(_ => of(showSnackBar({
          message: t({ id: "msg_search_descriptions_failed", message: "Failed to search for descriptions. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
          messageType: "ERROR",
        }))),
      )),
    )

const searchRecentManualTimeCommentsRpc = (request: SearchRecentManualTimeCommentsRequest): Observable<SearchRecentManualTimeCommentsResponse> =>
  grpc(() => preferencesClient.searchRecentManualTimeComments(request, null))

export default searchRecentManualTimeComments(searchRecentManualTimeCommentsRpc)
